import React, { useState, useEffect, Fragment } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Menu, Icon, Popup, MenuItemProps } from 'semantic-ui-react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const SideBar = ({ menuItems }:SideBarProps) => {
	const path:string = useLocation().pathname;

	const [ subMenuVisibility, setSubMenuVisibility ] = useState(Array.apply(false, Array<boolean>(menuItems.length)));

	// make sure the submenu doesn't stay open when they go to a different page
	useEffect(() => {
		setSubMenuVisibility(Array.apply(false, Array<boolean>(menuItems.length)));
	}, [path, menuItems.length]);

	return (
		<Menu vertical style={{margin: '0'}}>
			{menuItems.map((x, index) =>
				<Fragment key={index}>
					<Popup content={x.tooltip} position='right center' disabled={!x.tooltip} trigger={
						<MenuItem
							as={x.routeTo && Link}
							to={x.routeTo}
							active={path === x.routeTo || path.startsWith(x.routeTo + '/')}
							onClick={x.subMenu === undefined || x.subMenu === null || x.subMenu.length === 0 ? undefined : (e) => {
								setSubMenuVisibility(prevState => prevState.map((y, index2) => index2 === index ? !y : y));
							}}
							className={(x.subMenu !== undefined && x.subMenu !== null && x.subMenu.length > 0 && (subMenuVisibility[index] || x.subMenu.some(y => y.routeTo === path))) ? 'submenu-opens' : undefined}
						>
							<Icon className={x.iconName} size="large" />
						</MenuItem>
					} />
					{x.subMenu === undefined || x.subMenu === null || x.subMenu.length === 0 ? undefined :
						<div
							className='sub-menu-container enable-height-transition'
							style={{
								height: subMenuVisibility[index] || x.subMenu.some(y => y.routeTo === path) ? (4 * x.subMenu.length) + 'rem' : '0'
							}}
						>
							<Menu vertical>
								{x.subMenu.map((y, index2) => (
									<Popup key={index2} disabled={!y.tooltip} content={y.tooltip} position="right center" trigger={
										<MenuItem
											as={Link}
											to={y.routeTo}
											active={path === y.routeTo}
										>
											<Icon className={y.iconName} size="big" />
										</MenuItem>
									} />
								))}
							</Menu>
						</div>
					}
				</Fragment>
			)}
		</Menu>
	);
};

const MenuItem = ({ as, active, ...rest }:MenuItemProps) => {
	const secondaryColor = useSelector(state => state.ui.customer.secondaryColor);

	return <_styledMenuItem
		asRenamed={as}
		activeRenamed={active}
		secondarycolor={secondaryColor}
		{ ...rest }
	/>;
};

const _middleManMenuItem = ( {asRenamed, activeRenamed, ...rest }:MenuItemProps) => <Menu.Item as={asRenamed} active={activeRenamed} { ...rest } />;

const _styledMenuItem = styled(_middleManMenuItem)`
	&.active {
		border-left-color: ${p => p.secondarycolor} !important;
	}
`;

interface SideBarProps {
	menuItems:MenuItemProp[]
}

interface MenuItemProp {
	routeTo?:string,
	tooltip?:string,
	iconName?:string,
	subMenu?:MenuItemProp[]
}

export default SideBar;